<template>
  <label class="lbl--reset input--radio">
    <input
      type="radio"
      :name="name"
      :checked="this.value.toString() === this.data.toString()"
      @change="change"
      :disabled="isDisabled"
    />
    <span>{{ label }}</span>
  </label>
</template>

<script>
export default {
  props: ["name", "value", "label", "data", "isDisabled"],
  methods: {
    change() {
      this.$emit("change");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../../scss/modules/radio.scss";
</style>
